import React from "react";
import Meta from "../../components/Meta";

const About = () => {
  return (
    <>
      <Meta title="Хаяг холбох заавар || Bondgor Cargo" />
      {/* <!-- Page title --> */}
      <section className="relative pt-24 lg:pb-96">
        <div className="container">
          {/* <!-- Page Title --> */}
          <div className="mx-auto max-w-2xl py-16 text-center">
            <h1 className="font-display text-jacarta-700 mb-8 text-4xl font-medium dark:text-white">
              Хаяг холбох заавар
            </h1>
          </div>
        </div>
      </section>
      {/* <!-- Intro / Statistics --> */}

      <section className="pb-24">
        <div className="container">
          <figure className="before:bg-jacarta-900/25 rounded-xl relative mt-16 overflow-hidden rounded-3xl before:absolute before:inset-0 lg:-mt-96">
            <img
              src="/images/HAYG-HOLBOH-1.png"
              alt="gradient"
              className="h-full w-full"
            />
          </figure>
        </div>
      </section>
    </>
  );
};

export default About;
